/**
 * ForgotPasswordConfirmPage — autenticazione Phase 6 (IMPL-P6-001).
 *
 * UC-008 step 1 terminal page. The {@link ForgotPasswordForm} navigates here
 * regardless of whether the email is actually registered — anti-enumeration
 * compliance: the copy is intentionally neutral ("Se l'indirizzo è
 * registrato…") so it cannot leak account existence.
 */
import { Mail } from 'lucide-react';
import { AuthStatusPage } from '../components/AuthStatusPage';

export function ForgotPasswordConfirmPage() {
  return (
    <AuthStatusPage
      icon={Mail}
      tone="info"
      title="Email inviata"
      description="Se l'indirizzo è registrato, ti abbiamo inviato un link per reimpostare la password. Controlla la tua casella e anche la cartella Spam."
      primaryAction={{ label: 'Torna al login', to: '/accedi' }}
    />
  );
}
